import React from 'react';
import * as Icons from '@ant-design/icons';

/** Tipi nominali utili se vuoi validare */
export type AntdIconName = keyof typeof Icons;

/**
 * Renderizza dinamicamente un'icona di Ant Design a partire dal nome.
 * Supporta anche stringhe tipo "<InstagramOutlined/>".
 * Se il nome non esiste, usa FileTextOutlined come fallback.
 */
export function renderAntdIcon(
  iconName?: string | null,
  props?: React.ComponentProps<'span'> // className, style, ecc.
): React.ReactNode {
  const Fallback = Icons.FileTextOutlined as React.ComponentType<any>;
  if (!iconName) return <Fallback {...props} />;

  // normalizza da "<Icon/>" a "Icon"
  const name = iconName.replace(/[<>\s/]/g, '');
  const Comp = (Icons as any)[name] as React.ComponentType<any> | undefined;

  return Comp ? <Comp {...props} /> : <Fallback {...props} />;
}

/** (opzionale) per validare lato UI se un nome è disponibile */
export function isValidAntdIconName(name?: string | null): boolean {
  if (!name) return false;
  const normalized = name.replace(/[<>\s/]/g, '');
  return Object.prototype.hasOwnProperty.call(Icons, normalized);
}
